module.exports = __webpack_public_path__ + "static/img/product_bg.58b4b9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product_bg.png
// module id = x8lf
// module chunks = 0